import React from 'react';
import Swapers from '../../Carousel/Swapers/Swapers'; // Adjust the import path as needed
import './Gallery.css'; // Import the CSS file
import { imgURL } from '../../Config';
import { Link } from 'react-router-dom';

const Gallery = ({galleryData}) => {
  const renderGallerySlide = (image) => (
    <div className="item" key={image.id}>
      <div className="gallery-page__card">
        <img src={imgURL + image.thumbnail} alt={image.description} />
        <div className="gallery-page__card__hover">
          <Link to='gallery' className="img-popup">
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 15.0573H30.1147" stroke="white" strokeWidth="3" />
              <path d="M15.0586 0L15.0586 30.1149" stroke="white" strokeWidth="3" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <section className="gallery-page container-fluid">
      <div className="text-end">
      <Link to="/gallery"><button className='btn btn-sm btn-primary me-2'>View all</button>
      </Link></div>
      <div className="container">
        <div className="sec-title text-center pb-2">
          <h4 className="sec-title__tagline justify-content-center">Photo Gallery</h4>
        </div>
       {galleryData?.length && <div
          className="gallery-page__carousel acwadam-owl__carousel  acwadam-owl__carousel--basic-nav owl-carousel owl-theme"
        >
          <Swapers
            slidesData={galleryData}
            renderSlide={renderGallerySlide}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            autoplay={false}
            navigation={false}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: (galleryData?.length > 1) ? 1 : galleryData?.length },
              576: { slidesPerView: (galleryData?.length > 2) ? 2 : galleryData?.length },
              992: { slidesPerView: (galleryData?.length > 4) ? 4 : galleryData?.length },
            }}
          />
        </div>}
      </div>
    </section>
  );
};

export default Gallery;